export default __webpack_public_path__ + "static/media/vimeo-icon.dbac1a44.svg";